import Vue from 'vue';

// Import Froala Editor
import 'froala-editor/js/plugins.pkgd.min.js';
// Import third party plugins
import 'froala-editor/js/plugins/image.min.js';
import 'froala-editor/js/plugins/image_manager.min.js';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg';

Vue.use(VueFroala);
